import { Component, OnInit } from '@angular/core';
import {FastLinkDataService} from "../fastlinkdataservice";
import {interval, Subscription} from "rxjs";
import {environment} from "../../../environments/environment";
import {FASTLINKDATA} from "../fastlinkstruct";

@Component({
  selector: 'app-fastlinkmonitor',
  templateUrl: './fastlinkmonitor.component.html',
  styleUrls: ['./fastlinkmonitor.component.css']
})
export class FastlinkmonitorComponent implements OnInit {
  private updateSubscription: Subscription | undefined;
  fastLinkData: FASTLINKDATA | undefined;
  public loaderStatus: number = 0;

  constructor(private fastLinkDataService :FastLinkDataService) {
    console.log('FastlinkmonitorComponent Construct');
  }

  Counter(i: number) {
    return new Array(i);
  }


  ngOnInit(): void {
    this.GetData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  ReSubscribe(): void
  {
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.GetData();
      });
  }

  GetData() : void
  {
      this.loaderStatus = -1;
      this.updateSubscription?.unsubscribe();
      this.fastLinkDataService.GetData().subscribe({
        next: fastLinkData => {
          this.loaderStatus = 1;
          this.fastLinkData = fastLinkData;
          this.ReSubscribe();
        }
      });
  }


}
